export const jaJP = {
  translation: {
    "title/Crossnote": "クロスノート",
    "search/notes": "ノートを検索する",
    "search/notebooks": "ノートブックを検索する",
    "search/attachments": "添付を検索する",

    // Account
    "account/Anonymous": "匿名",
    "account/anonymous": "匿名",

    // General
    "general/go-back": "戻る",
    "general/sending": "送信中",
    "general/send": "送る",
    "general/cancel": "キャンセル",
    "general/add": "追加",
    "general/adding": "追加",
    "general/backed-up-at": "備份於",
    "general/created-at": "創建於",
    "general/modified-at": "修改於",
    "general/interacted-at": "交互於",
    "general/date-created": "作成日",
    "general/date-modified": "更新日",
    "general/date-interacted": "交互時間",
    "general/title": "表題",
    "general/saved-at": "保存於",
    "general/loading": "讀取中 ...",
    "general/loading-notifications": "通知を読み込んでいます ...",
    "general/failed-to-set": "設定に失敗しました",
    "general/update": "更新",
    "general/updated": "更新しました",
    "general/updating": "更新中",
    "general/close": "閉じる",
    "general/Note": "ノート",
    "general/notes": "ノート",
    "general/Settings": "設定",
    "general/Collaborators": "協力者",
    "general/collaborators": "協力者",
    "general/Backups": "バックアップ",
    "general/backups": "バックアップ",
    "general/Discussion": "話し合う",
    "general/discussion": "話し合う",
    "general/Notifications": "通知",
    "general/Username": "ユーザー名",
    "general/Email": "Eメール",
    "general/Password": "パスワード",
    "general/confirm-password": "もう一度パスワードを確認してください",
    "general/Continue": "継続する",
    "general/enter-username": "ユーザー名を入力してください",
    "general/vickymd": "VickyMD(微記)",
    "general/tags": "タグ",
    "general/add-a-tag": "タグを追加する",
    "general/private": "民間",
    "general/public": "公開可見",
    "general/friends-only": "友達にのみ表示",
    "general/anonymous": "匿名",
    "general/onymous": "公開署名",
    "general/Tag": "タグ",
    "general/no-tags": "タグなし",
    "general/Directory": "ディレクトリ",
    "general/Untitled": "無題",
    "general/untitled": "無題",
    "general/Unknown": "不明",
    "general/unknown": "不明",
    "general/Agree": "同意する",
    "general/Disagree": "同意しない",
    "general/Print": "印刷する",
    "general/Share": "シェア",
    "Editor": "編集者",
    "EDITOR": "編集者",
    "Viewer": "読者",
    "VIEWER": "読者",
    "Admin": "管理者",
    "ADMIN": "管理者",
    "ARCHIVED": "アーカイブされたノート",
    "ATTACHED NOTES": "添付ノート",
    "DELETED": "削除されたノート",
    "PINNED": "スティッキー",
    "OTHERS": "その他",
    "PUBLIC NOTES": "公開ノート",
    "FOLLOWINGS' NOTES": "關注人的筆記",
    "SHARED WITH ME": "私に共有する",
    "BOOKMARKS": "ブックマーク",
    "MY TAGS": "私のタグ",
    "general/enter-fullscreen-mode": "全画面モードに入る",
    "general/enter-presentation-mode": "スライドショーモードに入る",
    "general/math-preview": "数学プレビュー",
    "general/this-note-is-empty": "このノートには内容がありません",
    "general/this-notebook-is-empty": "このノートブックには内容がありません",
    "general/nothing-here": "ここには何もない",
    "general/no-notes-found": "他のノートは見つかりませんでした",
    "general/no-more-attachments-found": "添付が見つかりません",
    "general/no-more-notebooks-found": "ノートブックが見つかりません",
    "general/no-notifications-found": "他のニュースは見つかりませんでした",
    "general/clear-all": "すべてクリア",
    "general/Save": "保存",
    "general/Delete": "削除する",
    "general/Follow": "フォロー",
    "general/Following": "フォロー中",
    "general/Unfollow": "フォロー解除",
    "general/my-notes": "私のノート",
    "general/public-notes": "公開ノート",
    "general/followings-notes": "關注人的筆記",
    "general/shared-with-me": "私に共有する",
    "general/Bookmarks": "ブックマーク",
    "general/Archive": "アーカイブ",
    "general/Trash": "ゴミ箱",
    "general/new-note": "新しい添付",
    "general/new-attachment": "新しい",
    "general/profile-updated": "ユーザー情報が更新されました",
    "general/ID": "ID",
    "general/Audio": "音声",
    "general/Video": "映像",
    "general/source-url": "ソースリンク",
    "general/sign-in": "サインイン",
    "general/sign-up": "サインアップ",
    "general/Link": "リンク",
    "general/Upload": "アップロードする",
    "general/Uploading": "アップロードしています",
    "general/clicks": "クリック",
    "general/Processing": "処理中...",
    "general/please-wait": "しばらくお待ちください...",
    "general/please-sign-in-first": "最初にサインインしてください",
    "general/Languages": "言語",
    "general/track": "たどる",
    "general/Open": "開く",
    "general/Download": "ダウンロード",
    "general/Configure": "構成",
    "general/Update": "更新",
    "general/empty": "空",
    "general/Notebooks": "ノートブック",
    "general/add-a-notebook": "ノートブックを追加する",
    "general/add-a-note": "ノートを追加する",
    "general/add-an-attachment": "添付を追加する",
    "general/configure-the-notebook": "ノートブックを構成する",
    "general/notebook-name": "ノートブック名",
    "general/git-repository": "git リポジトリ",
    "general/optional": "オプション",
    "general/url": "Url",
    "general/branch": "ブランチ",
    "general/remember-username-and-password": "資格情報を記憶する",
    "general/stored-locally": "ローカルに保存",
    "general/cors-proxy": "CORS プロキシ",
    "general/why-cors-proxy": "なぜ CORS プロキシが必要なのですか?",
    "general/today": "今日",
    "general/todo": "Todo",
    "general/wiki": "Wiki",
    "general/tagged": "タグ",
    "general/untagged": "タグない",
    "general/encrypt": "暗号化",
    "general/encrypted": "暗号化",
    "general/decrypt": "復号化",
    "general/conflicted": "競合",
    "general/attachments": "添付",
    "general/Pin": "ピン",
    "general/Encryption": "暗号化",
    "general/Fullscreen": "フルスクリーン",
    "general/change-file-path": "ファイル パスの変更",
    "general/create-a-copy": "コピーを作成する",
    "general/restore-checkout": "復元 (git checkout)",
    "general/download-pull": "ダウンロード (git pull)",
    "general/upload-push": "アップロード (git pull & git push)",
    "general/disable-the-encryption-on-this-note":
      "このノートの暗号化を無効にする",
    "general/encrypt-this-note-with-password":
      "このノートをパスワードで暗号化する",
    "general/disable-encryption": "暗号化を無効にする",
    "general/decrypt-this-note": "このノートを復号化する",
    "general/upload-the-profile": "プロファイルをアップロードする",
    "general/commit-message": "コミット メッセージ",
    "general/upload-notebook": "ノートブックをアップロードする",
    "general/Comments": "コメント",
    "general/Source": "ソース",
    "general/Description": "説明",
    "general/Edit": "編集",
    "general/Rename": "変更",
    "general/rename-directory": "ディレクトリ名を変更する",
    "general/delete-directory": "ディレクトリ名を削除する",
    "general/rename-tag": "タグの名前を変更する",
    "general/delete-tag": "タグを削除する",
    "general/notebook-updates-found": "ノートブックの更新が見つかりました",
    "general/update-the-notebook": "ノートブックを更新する",
    "general/check-notebook-updates-periodically":
      "ノートブックの更新を定期的に確認する",
    "general/minutes": "分",
    "general/hard-reset": "ハードリセット",
    "general/Default": "既定",
    "general/Vim": "Vim",
    "general/Emacs": "Emacs",
    "general/Desc": "降順",
    "general/Asc": "昇順",

    // Error
    "error/authentication-failed": "認証に失敗しました",
    "error/failed-to-upload-notebook":
      "ノートブックをアップロードできませんでした",
    "error/failed-to-download-notebook":
      "ノートブックをダウンロードできませんでした ...",
    "error/notebook-already-exists": "ノートブックは既に存在します",
    "error/invalid-git-url-prefix": "無効な git URL プレフィックス",
    "error/please-resolve-conflicts": "最初に競合を解決してください",
    "error/failed-to-disable-encryption": "暗号化を無効にできませんでした",
    "error/decryption-failed": "復号化に失敗しました",
    "error/failed-to-change-file-path": "ファイル パスの変更に失敗しました",
    "error/failed-to-create-widget": "ウィジェットの作成に失敗しました",
    "error/failed-to-load-widget": "ウィジェットを読み込めませんでした",
    "error/failed-to-update-the-notebook": "ノートブックの更新に失敗しました",

    // Success
    "success/notebook-uploaded": "ノートブックがアップロードされます",
    "success/notebook-downloaded": "ノートブックがダウンロードされます",

    // Info
    "info/downloading-notebook": "ノートブックをダウンロード中",

    // Note
    "note/unarchive-note": "アーカイブ解除",
    "note/archive-note": "アーカイブ",
    "note/delete-forever": "完全に削除",
    "note/delete-note": "削除する",
    "note/restore-note": "回復する",
    "note/report-note": "報告書",
    "note/open-in-crossnote-website": "クロスノートのウェブサイトで開く",

    // NoteTags
    "note-tags/send-suggestion-failure": "提案の送信に失敗しました",
    "note-tags/suggestion-sent": "提案を送信しました",
    "note-tags/suggest-a-tag-to-this-note": "このノートのタグを提案する",

    // UserTags
    "user-tags/follow-a-tag": "タグをフォロー",

    // Notifications
    "notifications/refresh": "更新して新しいメッセージを表示",
    "notifications/new-version-available":
      "クロスノートの新バージョンが利用可能です!",

    // Settings
    "settings/about-this-project": "このプロジェクトについて",
    "settings/issues-and-feature-requests":
      "問題を発見したか、機能要求がありますか？",
    "settings/uploading-cover-image": "カバー画像をアップロード",
    "settings/upload-image-failure": "画像のアップロードに失敗しました",
    "settings/Cover": "カバー写真",
    "settings/enter-cover-image-url": "カバー画像のリンクを入力してください",
    "settings/upload-image": "写真をアップロードする",
    "settings/Avatar": "アバター",
    "settings/enter-avatar-image-url": "アバター画像リンクを入力してください",
    "settings/Name": "名",
    "settings/enter-name":
      "名前を入力してください（これはユーザー名ではありません）",
    "settings/editor-cursor-color": "エディターのカーソルの色",
    "settings/hello": "こんにちは，",
    "settings/world": "世界！",
    "settings/linked-with-github-account":
      "GitHub アカウントがリンクされました",
    "settings/link-with-github-account": "GitHub アカウントへのリンク",
    "settings/log-out": "ログアウトする",
    "settings/author-name": "著者名",
    "settings/author-email": "著者の電子メール",
    "settings/theme": "テーマ",
    "settings/created-cloud-widgets-count": "作成されたクラウドウィジェット数",
    "settings/key-map": "キーマップ",

    // Preview
    "preview/attach-a-note": "ノートを添付",
    "preview/crossnote-untitled": "クロスノート - 無題",
    "preview/edit-this-note": "このノートを編集",

    // ProfileCard
    "profile-card/followings": "フォロー",
    "profile-card/followers": "ファン",
    "profile-card/Followings": "フォロー",
    "profile-card/Followers": "ファン",
    "profile-card/notes": "ノート",
    "profile-card/follow-user-failure": "このユーザーをフォローできません",
    "profile-card/followed-user": "このユーザーをフォローしました",
    "profile-card/unfollow-user-failure":
      "このユーザーのフォローを解除できません",
    "profile-card/unfollowed-user": "このユーザーのフォローを解除しました",

    // TagCard
    "tag-card/pin-to-my-notes-page": "ノートページにピン留めする",

    // Interaction panel
    "interaction-panel/show-attached-notes": "添付されたノートを表示",
    "interaction-panel/add-comment": "コメントを追加",
    "interaction-panel/add-reaction": "絵文字を追加",

    // Editor
    "editor/loading-your-note": "ノートを読む...",
    "editor/sync-failure":
      "同期に失敗しました... Webページを再起動してください",
    "editor/saving": "保存中...",
    "editor/save-failure": "保存失敗",
    "editor/saved": "保存しました",
    "editor/update-note-failure": "ノートの更新に失敗しました",
    "editor/placeholder": "#  こんにちは 😀 コマンドに 「/」 と入力します。",
    "editor/ln": "行",
    "editor/col": "列",

    // * NoteControl
    "editor/note-control/allow-readers-to-suggest-note-tags":
      "読者がノートを提案できるタグ",
    "editor/note-control/allow-readers-to-attach-notes-under-this-note":
      "読者がこのノートの下にノートを添付できるようにする",
    "editor/note-control/inherit-parent-note-collaborators-list":
      "親ノートを継承した共同編集者のリスト",
    "editor/note-control/note-visibility-hint":
      "すべての共同編集者もこのノートを見ることができます",
    "editor/note-control/allow-readers-to-attach-notes-unchecked":
      "あなたとこのノートを編集または管理できるすべての共同編集者向け",
    "editor/note-control/allow-readers-to-attach-notes-checked":
      "このノートを見ることができるすべての人のために",
    "editor/note-control/enter-parent-note-id":
      "親ノートのIDを入力してください",
    "editor/note-control/attach-note-failure": "ノートの添付に失敗しました",
    "editor/note-control/unattach-note-failure":
      "ノートの添付解除に失敗しました",
    "editor/collaborator-hint": " - このノートが表示されます",
    "editor/shareable-link-hint":
      "このリンクを知っている全員がログインせずにこのノートを表示/変更できます",

    // * BackupsControl
    "editor/backups-control/create-backup": "バックアップを作成",
    "editor/backups-control/delete-this-backup": "このバックアップを削除",
    "editor/backups-control/create-backup-failure":
      "バックアップの作成に失敗しました",
    "editor/backups-control/backup-created": "バックアップを作成しました",
    "editor/backups-control/delete-backup-failure":
      "バックアップの削除に失敗しました",
    "editor/backups-control/backup-deleted": "バックアップを削除しました",
    "editor/backups-control/cloud-version": "クラウド版",
    "editor/backups-control/backup-name": "バックアップ名",

    // * CollaboratorasControl
    "editor/collaborators-control/set-collaborator-role-failure":
      "共同編集者の役割を設定できませんでした",
    "editor/collaborators-control/add-collaborator-failure":
      "共同編集者の追加に失敗しました",
    "editor/collaborators-control/collaborator-removed":
      "共同編集者を削除しました",
    "editor/collaborators-control/collaborator-added":
      "共同編集者が追加されました",
    "editor/collaborators-control/can-view": "閲覧できる",
    "editor/collaborators-control/can-edit": "編集可能",
    "editor/collaborators-control/can-administrate": "管理者が管理できます",

    // * EditorToolBar
    "editor/toolbar/insert-image": "画像を挿入",
    "editor/toolbar/upload-local-images": "ローカルイメージをアップロードする",
    "editor/toolbar/capture-webpage": "ウェブページ全体をキャプチャする",
    "editor/toolbar/insert-clock": "時計を挿入",
    "editor/toolbar/insert-emoji": "絵文字を挿入",
    "editor/toolbar/insert-media": "メディアを挿入する",
    "editor/toolbar/insert-audio": "音声を挿入",
    "editor/toolbar/netease-music": "Netease Cloud Music",
    "editor/toolbar/insert-video": "ビデオを挿入",
    "editor/toolbar/insert-youtube": "Youtube を挿入",
    "editor/toolbar/insert-bilibili": "Bilibili を挿入",
    "editor/toolbar/insert-slide": "スライドを挿入",
    "editor/toolbar/insert-ocr": "OCRを挿入",
    "editor/toolbar/insert-kanban": "かんばんを挿入",
    "editor/toolbar/insert-abc-notation": "ABC notation を挿入",
    "editor/toolbar/insert-header-1": "第1レベルの見出しを挿入",
    "editor/toolbar/insert-header-2": "第2レベルの見出しを挿入",
    "editor/toolbar/insert-header-3": "第3レベルの見出しを挿入",
    "editor/toolbar/insert-header-4": "第4レベルの見出しを挿入",
    "editor/toolbar/insert-header-5": "第5レベルの見出しを挿入",
    "editor/toolbar/insert-header-6": "第6レベルの見出しを挿入",
    "editor/toolbar/bold": "太字",
    "editor/toolbar/italic": "斜体",
    "editor/toolbar/strikethrough": "取り消し 線",
    "editor/toolbar/insert-inline-code": "インラインコードを挿入",
    "editor/toolbar/insert-blockquote": "参照を挿入",
    "editor/toolbar/insert-unordered-list": "順不同リストを挿入",
    "editor/toolbar/insert-ordered-list": "順序付きリストを挿入",
    "editor/toolbar/insert-link": "リンクを挿入",
    "editor/toolbar/insert-table": "テーブルを挿入",
    "editor/toolbar/insert-comment":
      "クロスノートクラウドコメントウィジェットを挿入",
    "editor/toolbar/insert-github-gist": "GitHub Gist を挿入",

    // * NoteControl
    "editor/note-control/tag-added": "タグが追加されました",
    "editor/note-control/tag-deleted": "タグが削除されました",
    "editor/note-control/set-note-visibility-failure":
      "ノートの可視性の設定に失敗しました",
    "editor/note-control/note-visibility-updated":
      "ノートの可視性が更新されました",
    "editor/note-control/set-author-visibility-failure":
      "著者の可視性を設定できませんでした",
    "editor/note-control/author-visibility-updated":
      "著者の可視性が更新されました",
    "editor/note-control/editor-mode": "エディターモード",
    "editor/note-control/source-code": "ソースコード",
    "editor/note-control/preview": "プレビュー",
    "editor/note-control/split-view": "分割ビュー",
    "editor/note-control/pin-preview": "右にピンプレビュー",
    "editor/note-control/display-modification-records": "変更レコードの表示",
    "editor/note-control/note-visibility": "ノートの可視性",
    "editor/note-control/author-visibility": "著者の可視性",
    "editor/note-control/shareable-link": "共有可能なリンク",
    "editor/note-control/copy-to-clipboard": "ペーストボードにコピー",
    "editor/note-control/link-to-preview": "プレビューへのリンク",
    "editor/note-control/link-to-editor": "エディターへのリンク",
    "editor/note-control/attach-to-note": "ノートに添付",
    "editor/note-control/source-added": "URL が追加されました",
    "editor/note-control/source-deleted": "URL が削除されました",
    "editor/note-control/invalid-note-source": "無効な URL",
    "editor/note-control/add-note-source": "関連する URL を追加しました",
    "editor/note-control/note-source-hint":
      "同じ URL 上のノートはグループ化されます",
    "editor/note-control/enter-note-source": "URL を入力してください",

    // AvatarPanel
    "avatar-panel/this-note-is-private": "このノートは非公開です",
    "avatar-panel/this-note-is-public": "このノートは一般公開されています",
    "avatar-panel/this-note-is-friends-only":
      "このノートは友達にのみ表示されます",
    "avatar-panel/you-are-anonymous": "あなたは匿名です",

    // FileExporter
    "file-exporter/name": "ファイルのエクスポート",
    "file-exporter/orientation": "方向",
    "file-exporter/portrait": "縦",
    "file-exporter/landscape": "水平",
    "file-exporter/paper-size": "用紙サイズ",
    "file-exporter/unit": "単位",
    "file-exporter/margin-top": "上マージン",
    "file-exporter/margin-bottom": "下マージン",
    "file-exporter/margin-left": "左マージン",
    "file-exporter/margin-right": "右マージン",

    // Utils
    "utils/uploading-image": "画像をアップロードしています...",
    "utils/upload-image-failure": "画像のアップロードに失敗しました",

    // Notification
    // * CommentPostingNotification
    "notification/replies-to-you-in": "返信する",
    // somone's
    "notification/'s-note": "ノート ",
    // * NoteReactionNotification
    "notification/added": " 添加了",
    // some reaction
    "notification/to-your-note": "到你的筆記",
    "notification/add-you-as": "添加了你作為",
    // some role
    "notification/of-note": "到筆記",
    // * NoteTagSuggestion
    "notification/add-tag-failure": "タグの追加に失敗しました",
    "notification/suggested-to-add-tag": "タグの追加を提案する",
    // * UserFollowingNotification
    "notification/started-following-you": "あなたをフォローし始めました",
    // * BookmarkNotification
    "notification/bookmarked-your-note": "あなたのノートをブックマーク",
    "notification/view-more-notifications": "その他の通知を表示する",

    // Widgets
    "widget/autoplay": "自動再生",
    "widget/controls": "コントローラー",
    "widget/loop": "サイクル",
    "widget/muted": "ミュート",
    "widget/creating-widget": "ウィジェットを作成しています",
    "widget/loading-widget": "ウィジェットを読み込んでいます",
    "widget/crossnote.image/thanks_sm_ms":
      "無料のドローイングベッドサービスを提供してくれたsm.msに感謝します。",
    "widget/crossnote.audio/audio_element_fail":
      "お使いのブラウザはオーディオ要素をサポートしていません",
    "widget/crossnote.audio/source-url-placeholder":
      "ここにオーディオファイルのソースリンクを入力し、「Enter」キーを押して挿入します",
    "widget/crossnote.video/video_element_fail":
      "お使いのブラウザは動画動画要素をサポートしていません",
    "widget/crossnote.bilibili/error_message":
      "エラー：https://www.bilibili.com/video/av79126732のようなリンクのみがサポートされています",
    "widget/crossnote.youtube/error_message":
      "エラー：https://www.youtube.com/watch?v=MmB9b5njVbAなどのリンクのみがサポートされています",
    "widget/crossnote.auth/welcome": "クロスノートへようこそ",
    "widget/crossnote.auth/doesnt-have-account":
      "アカウントなし？ 作成しましょう😉！",
    "widget/crossnote.auth/forgot_password": "パスワードを忘れました 😣？",
    "widget/crossnote.auth/failed_to_send_code":
      "確認コードをメールに送信できませんでした",
    "widget/crossnote.auth/verification_code_sent":
      "確認コードが送信されました ",
    "widget/crossnote.auth/failed_to_reset_password":
      "パスワードをリセットできませんでした",
    "widget/crossnote.auth/password_reset": "パスワードがリセットされました",
    "widget/crossnote.auth/password-mismatch": "一貫性のないパスワード",
    "widget/crossnote.auth/hello": "こんにちは，",
    "widget/crossnote.auth/enter-the-verification-code":
      "確認コードを入力してください",
    "widget/crossnote.auth/get-code": "確認コードを取得する",
    "widget/crossnote.auth/sign-in-with-github-account":
      "GitHub アカウントでサインインする",
    "widget/crossnote.auth/already-have-an-account":
      "すでにアカウントをお持ちですか？",
    "widget/crossnote.auth/reset-password": "パスワードをリセット",
    "widget/crossnote.auth/Or": "または",
    "widget/crossnote.bilibili/Bilibili": "Bilibili",
    "widget/crossnote.bilibili/bilibili-video-url": "Bilibili ビデオリンク",
    "widget/crossnote.bilibili/url-placeholder":
      "ここにビリビリのビデオへのリンクを挿入し、「Enter」を押して挿入します",
    "widget/crossnote.image/image-helper": "画像アシスタント",
    "widget/crossnote.image/image-url-placeholder":
      "ここに画像リンクを入力し、「Enter」を押して挿入します",
    "widget/crossnote.image/click-here-to-browse-image-file":
      "画像ファイルを選択するにはここをクリックしてください",
    "widget/crossnote.neteasemusic/song-id-placeholder":
      "NetEase Cloud Music SongデジタルIDを入力してください",
    "widget/crossnote.video/video-url-placeholder":
      "ここにビデオファイルのソースリンクを入力し、「Enter」を押して挿入します",
    "widget/crossnote.video/poster-url": "カバー画像リンク（オプション）",
    "widget/crossnote.video/poster-url-placeholder":
      "ここにカバー画像のリンクを入力してください。",
    "widget/crossnote.youtube/youtube-video-url": "Youtube ビデオリンク",
    "widget/crossnote.youtube/youtube-video-url-placeholder":
      "Youtubeビデオへのリンクをここに挿入し、「Enter」を押して挿入します",
    "widget/crossnote.ocr/ocr": "OCR - Optical character recognition",
    "widget/crossnote.ocr/local-image": "ローカル画像",
    "widget/crossnote.ocr/recognize-text-in-languages":
      "次の言語のテキストを認識する",
    "widget/crossnote.ocr/start-ocr": "開始文字識別",
    "widget/crossnote.ocr/extra-settings": "追加設定",
    "widget/crossnote.ocr/grayscale": "グレースケール",
    "widget/crossnote.kanban/add-column": "新しい列を追加する",
    "widget/crossnote.github_gist/title": "GitHub Gist を埋め込む",
    "widget/crossnote/github_gist/enter-github-gist-url":
      "GitHub Gist URL を入力してください",

    // Tesseract
    "tesseract/loading tesseract core": "loading tesseract core",
    "tesseract/initializing tesseract": "initializing tesseract",
    "tesseract/initialized tesseract": "initialized tesseract",
    "tesseract/loading language traineddata": "loading language traineddata",
    "tesseract/loaded language traineddata": "loaded language traineddata",
    "tesseract/initializing api": "initializing api",
    "tesseract/initialized api": "initialized api",
    "tesseract/recognizing text": "recognizing text",

    // Comment widget
    "widget/crossnote.comment/reply-to-this-user": "このユーザーに返信",
    "widget/crossnote.comment/add-reaction-to-this-comment":
      "このコメントへの応答を追加します",
    "widget/crossnote.comment/edit-this-message": "このコメントを編集する",
    "widget/crossnote.comment/modified-comment": "変更されたコメント",
    "widget/crossnote.comment/post-comment-failure":
      "コメントの送信に失敗しました",
    "widget/crossnote.comment/unsubscribe-info": "コメントの購読を解除する",
    "widget/crossnote.comment/subscribe-info": "コメントを購読する",
    "widget/crossnote.comment/view-more-comments": "その他のコメントを表示する",

    // Dialogs
    "delete-note-dialog/title": "このノートを削除しますか?",
    "delete-note-dialog/subtitle": "この操作を取り消すことはできません。",
    "delete-directory-dialog/title": "このディレクトリを削除しますか？",
    "delete-directory-dialog/subtitle":
      "すべてのサブディレクトリとノートも削除されます。この操作を取り消すことはできません。",
    "delete-tag-dialog/title": "このタグを削除しますか？",
    "delete-tag-dialog/subtitle":
      "すべてのサブタグも削除されます。この操作を取り消すことはできません。",
    "add-notebook-dialog/disclaimer":
      "すべてのノートブックデータは、ブラウザにローカルに保存されます。ノートブックデータを当社のサーバーにアップロードすることはありません。",
    "edit-image-dialog/title": "画像を編集する",
    "edit-image-dialog/image-url": "画像の URL",
    "edit-image-dialog/image-title": "画像のタイトル",
    "edit-image-dialog/image-alt-text": "画像代替テキスト",
    "language-selector-dialog/subtitle": "希望する言語を選択してください",

    // react-ios-pwa-prompt
    "react-ios-pwa-prompt/copy-title": "ホーム画面に追加",
    "react-ios-pwa-prompt/copy-body":
      "このウェブサイトにはアプリ機能があります。フルスクリーンとオフライン中に使用するためにあなたのホーム画面にそれを追加します。",
    "react-ios-pwa-prompt/copy-share-button-label":
      "1) [共有] ボタンを押します。",
    "react-ios-pwa-prompt/copy-add-home-button-label":
      "2) 「ホーム画面に追加」を押します。",

    // git
    "git/status/ignored": "無視",
    "git/status/unmodified": "未変更",
    "git/status/*modified": "*変更済み",
    "git/status/*deleted": "*削除済み",
    "git/status/*added": "*追加",
    "git/status/absent": "欠落",
    "git/status/modified": "変更済み",
    "git/status/deleted": "削除済み",
    "git/status/added": "追加",
    "git/status/*unmodified": "*未変更",
    "git/status/*absent": "*欠落",
    "git/status/*undeleted": "*削除されませんでした",
  },
};
